@if (!programsArray().length) {
	<div class="fw-bold w-100 h-100 d-flex justify-content-center align-items-center">Brak</div>
} @else {
	<div class="d-flex flex-row gap-2 mt-2">
		<button mat-raised-button color="primary" (click)="expandAll()">Rozwiń</button>
		<button mat-raised-button color="warn" (click)="collapseAll()">Zwiń</button>
	</div>
	<div class="d-flex flex-column gap-2 overflow-y-scroll scroll-wrapper pe-3">
		<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="nodes-tree w-100">
			<mat-tree-node
				*matTreeNodeDef="let node"
				matTreeNodeToggle
				class="w-100"
				(click)="toggleNodeExpandedState(node)"
			>
				<div class="d-flex flex-row gap-1 justify-content-between align-items-center w-100 node">
					{{ node.name }}
					<button
						mat-mini-fab
						color="primary"
						class="theme-smaller-buttons"
						(click)="handleNodeClick(node.id, node.type, action())"
						[disabled]="buttonDisabled()"
					>
						@if (action() === ParticipantsTabAction.LEAVE) {
							<i class="fas fa-angles-left"></i>
						} @else {
							<i class="fas fa-angles-right"></i>
						}
					</button>
				</div>
			</mat-tree-node>
			<mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" class="w-100 node">
				<div class="mat-tree-node mt-2 w-100 test d-flex align-items-center">
					<button
						mat-icon-button
						matTreeNodeToggle
						(click)="toggleNodeExpandedState(node)"
						[attr.aria-label]="'toggle ' + node.name"
					>
						@if (treeControl.isExpanded(node)) {
							<i class="fas fa-chevron-down"></i>
						} @else {
							<i class="fas fa-chevron-right"></i>
						}
					</button>
					<div class="d-flex flex-row gap-3 justify-content-between align-items-center w-100">
						@if (node.type === NodeType.RESERVATION) {
							<span class="badge bg-primary">{{ node.name }}</span>
						} @else {
							{{ node.name }}
						}
						<button
							mat-mini-fab
							color="primary"
							class="theme-smaller-buttons"
							(click)="handleNodeClick(node.id, node.type, action())"
							[disabled]="buttonDisabled()"
						>
							@if (action() === ParticipantsTabAction.LEAVE) {
								<i class="fas fa-angles-left"></i>
							} @else {
								<i class="fas fa-angles-right"></i>
							}
						</button>
					</div>
				</div>
				<div [class.nodes-tree-invisible]="!treeControl.isExpanded(node)" role="group">
					<ng-container matTreeNodeOutlet></ng-container>
				</div>
			</mat-nested-tree-node>
		</mat-tree>
	</div>
}
